import { Component } from '@angular/core';
import { CommunicationBuilderDirective } from '@shared/components/communication/communication-builder.directive';
import { TranslateService } from '@ngx-translate/core';
import { ContactService, GuardService } from '@shared/services';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-communication-item',
    templateUrl: './communication-item.component.html',
    styleUrls: ['./communication-item.component.scss'],
    standalone: false
})
export class CommunicationItemComponent extends CommunicationBuilderDirective {
    constructor(
        translateService: TranslateService,
        guardService: GuardService,
        datePipe: DatePipe,
        contactService: ContactService
    ) {
        super(translateService, guardService, datePipe, contactService);
    }
}
